import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { getListKunjunganByGroup } from "stores";
import { showUrlDokumenKunjungan } from "stores";
import { ColorRing, Dna, Watch } from "react-loader-spinner";
import { showUrlBuktiKunjungan } from "stores";
import GoogleMapReact from "google-map-react";
import "./ListKunjunganByGroup.css";

function ListKunjunganByGroup(data) {
  //   console.log(data, "DATAA");
  const dispatch = useDispatch();
  const korcab = useSelector((state) => state.korcabReducer);
  const urlPreview = korcab.urlDokumenKunjungan;
  const handleClick = () => {
    dispatch({ type: "SET_KUNJUNGAN_BY_GROUP", data: true });
  };
  // console.log(korcab, "KORCAB");
  const [listKunjunganPerGroup, setListKunjunganPerGroup] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  //   const [searchText, setSearchText] = React.useState("");
  const [modalDetails, setModalDetails] = React.useState(false);
  const [detailKunjungan, setDetailKunjungan] = React.useState([]);
  const [buktiKunjungan, setBuktiKunjungan] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };
  const formatRupiah = (angka) => {
    const numberFormat = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    });
    return numberFormat.format(angka);
  };

  const handleClickKunjungan = (val) => {
    setModalDetails(!modalDetails);
    setDetailKunjungan(val);
    setLoading(true); // Mulai loading
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    setBuktiKunjungan(
      showUrlDokumenKunjungan(dispatch, {
        urlImage: val.buktiKunjungan,
      })
    );
    setLatitude(parseFloat(val.lat));
    setLongitude(parseFloat(val.long));
  };
  React.useEffect(() => {
    let tmp =
      korcab.listDataKunjunganByGroup.docs &&
      korcab.listDataKunjunganByGroup.docs.map((val) => {
        return {
          ...val,
          action: (
            <div className="action-buttons-group">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Details Group Kunjungan</Tooltip>}
              >
                <Button
                  className="btn-action-custom btn-detail-blue"
                  onClick={() => handleClickKunjungan(val)}
                >
                  <i className="fas fa-info"></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
    setListKunjunganPerGroup(tmp);
  }, [korcab.listDataKunjunganByGroup]);

  const AnyReactComponent = ({ text }) => (
    <div style={{ color: "red", fontWeight: "bold" }}>
      <i className="fas fa-map-marker-alt"></i> {text}
    </div>
  );

  const defaultProps = {
    center: {
      lat: 0,
      lng: 0,
    },
    zoom: 11,
  };

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getStatusStyle = (status) => {
    switch (status) {
      case "Progress":
        return {
          fontWeight: "bold",
          backgroundColor: "#FDE5DD",
          textColor: "#F85317",
        };
      case "Done":
        return {
          fontWeight: "bold",
          backgroundColor: "#BAD9FD",
          textColor: "#1776F1",
        };
      default:
        return {};
    }
  };

  const getKeputusan = (keputusan) => {
    switch (keputusan) {
      case "Tunda":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE6CC",
          textColor: "#FF7F00",
        };
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Disetujui":
        return {
          fontWeight: "bold",
          backgroundColor: "#E4F5C9",
          textColor: "#87CB16",
        };
      case "Ditolak":
        return {
          fontWeight: "bold",
          backgroundColor: "#FF0000",
          textColor: "#FFE6E6",
        };
      default:
        return {};
    }
  };

  const getHasil = (hasilNasabah) => {
    switch (hasilNasabah) {
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Pinjam":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      case "Perhitungan Minus":
        return {
          fontWeight: "bold",
          backgroundColor: "#F2E6FF",
          textColor: "#7F00FF",
        };
      case "-":
        return {
          fontWeight: "bold",
          textColor: "#000000",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "56px", // override the row height
        fontFamily: "Poppins, sans-serif",
      },
    },
    headRow: {
      style: {
        minHeight: "50px",
        backgroundColor: "#f8fafc",
        borderBottom: "2px solid #e2e8f0",
        fontFamily: "Poppins, sans-serif",
      },
    },
    headCells: {
      style: {
        fontWeight: "700",
        fontSize: "13px",
        color: "#475569",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "center",
      },
    },
  };

  const colGroupKunjungan = [
    {
      name: "No",
      width: "100px",
      center: true,
      // selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
      selector: (row, index) => index + korcab.groupKujunganById.pagingCounter,
    },
    {
      name: "ID Group Kunjungan",
      minWidth: "290px",
      center: true,
      selector: (row) => row.idGroupKunjungan,
    },
    {
      name: "ID Pinjaman",
      minWidth: "290px",
      center: true,
      selector: (row) => (row.bapLoan === "" ? "-" : row.bapLoan),
    },
    {
      name: "Tgl Kunjungan",
      minWidth: "150px",
      center: true,
      selector: (row) => moment(row.tglKunjungan).format("DD MMMM YYYY"),
    },
    {
      name: "Cabang",
      minWidth: "290px",
      center: true,
      selector: (row) => (!row.cabang ? "-" : row.cabang.namaCabang),
    },
    {
      name: "Area Manager",
      minWidth: "290px",
      center: true,
      selector: (row) => (!row.areaManager ? "-" : row.areaManager.nama),
    },
    {
      name: "Supervisor",
      minWidth: "290px",
      center: true,
      selector: (row) => (!row.supervisor ? "-" : row.supervisor.nama),
    },
    {
      name: "Marketing",
      minWidth: "290px",
      center: true,
      selector: (row) => (!row.marketing ? "-" : row.marketing.nama),
    },
    {
      name: "Koor Cabang",
      minWidth: "290px",
      center: true,
      selector: (row) => (!row.korcab ? "-" : row.korcab.nama),
    },
    {
      name: "Nett",
      minWidth: "180px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.nett);
        return formattedValue;
      },
    },
    {
      name: "Keputusan",
      minWidth: "200px",
      center: true,
      selector: (row) => row.keputusan,
      cell: (row) => {
        let badgeClass = "badge-neutral";
        if (row.keputusan === "Disetujui") badgeClass = "badge-disetujui";
        else if (row.keputusan === "Ditolak") badgeClass = "badge-ditolak";
        else if (row.keputusan === "Tunda") badgeClass = "badge-tunda";
        else if (row.keputusan === "Batal") badgeClass = "badge-batal";
        return (
          <span className={`modern-badge-pill ${badgeClass}`}>
            {row.keputusan || "-"}
          </span>
        );
      },
    },
    {
      name: "Hasil",
      minWidth: "200px",
      center: true,
      selector: (row) => row.hasil,
      cell: (row) => {
        const hasil =
          row.hasil === ""
            ? "-"
            : row.hasil === "Perhitungan minus"
              ? "Perhitungan Minus"
              : row.hasil;
        let badgeClass = "badge-neutral";
        if (hasil === "Batal") badgeClass = "badge-batal";
        else if (hasil === "Pinjam") badgeClass = "badge-pinjam";
        else if (hasil === "Perhitungan Minus") badgeClass = "badge-minus";
        return (
          <span className={`modern-badge-pill ${badgeClass}`}>
            {hasil}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "200px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getListKunjunganByGroup(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      idGroup: data.data,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);
  return (
    <>
      <Modal
        size="xl"
        show={modalDetails}
        onHide={() => {
          setModalDetails(false);
        }}
        centered
        className="modal-custom-detail"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: "700", color: "#1e293b", fontSize: "20px" }}>
            Detail Kunjungan Nasabah
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {/* Kolom Kiri: Informasi Kunjungan */}
            <Col xs={12} lg={6} className="mb-4 mb-lg-0">
              <div className="detail-section-title">
                <i className="fas fa-clipboard-list"></i> Informasi Detail Kunjungan
              </div>
              <div className="profile-summary-grid">
                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-calendar-day"></i> Tgl Kunjungan
                  </span>
                  <span className="profile-value">
                    {moment(detailKunjungan.tglKunjungan).format("DD MMMM YYYY")}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-hand-holding-usd"></i> Plafond
                  </span>
                  <span className="profile-value">
                    {formatRupiah(detailKunjungan.plafond || 0)}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-wallet"></i> Nett
                  </span>
                  <span className="profile-value">
                    {formatRupiah(detailKunjungan.nett || 0)}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-stamp"></i> Keputusan
                  </span>
                  <span className="profile-value">
                    {detailKunjungan.keputusan === "Disetujui" && (
                      <span className="modern-badge-pill badge-disetujui">Disetujui</span>
                    )}
                    {detailKunjungan.keputusan === "Ditolak" && (
                      <span className="modern-badge-pill badge-ditolak">Ditolak</span>
                    )}
                    {detailKunjungan.keputusan === "Tunda" && (
                      <span className="modern-badge-pill badge-tunda">Tunda</span>
                    )}
                    {detailKunjungan.keputusan === "Batal" && (
                      <span className="modern-badge-pill badge-batal">Batal</span>
                    )}
                    {!detailKunjungan.keputusan && (
                      <span className="modern-badge-pill badge-neutral">-</span>
                    )}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-poll-h"></i> Hasil
                  </span>
                  <span className="profile-value">
                    {detailKunjungan.hasil === "Batal" && (
                      <span className="modern-badge-pill badge-batal">Batal</span>
                    )}
                    {detailKunjungan.hasil === "Pinjam" && (
                      <span className="modern-badge-pill badge-pinjam">Pinjam</span>
                    )}
                    {detailKunjungan.hasil === "Perhitungan Minus" && (
                      <span className="modern-badge-pill badge-minus">Perhitungan Minus</span>
                    )}
                    {!detailKunjungan.hasil && (
                      <span className="modern-badge-pill badge-neutral">-</span>
                    )}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-map-marked"></i> Wilayah
                  </span>
                  <span className="profile-value">
                    {detailKunjungan.wilayah ? detailKunjungan.wilayah.namaWilayah : "-"}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-user-shield"></i> Area Manager
                  </span>
                  <span className="profile-value">
                    {detailKunjungan.areaManager ? detailKunjungan.areaManager.nama : "-"}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-user-tie"></i> Supervisor
                  </span>
                  <span className="profile-value">
                    {detailKunjungan.supervisor ? detailKunjungan.supervisor.nama : "-"}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-user-tag"></i> Marketing
                  </span>
                  <span className="profile-value">
                    {detailKunjungan.marketing ? detailKunjungan.marketing.nama : "-"}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-user-friends"></i> Koordinator Cabang
                  </span>
                  <span className="profile-value">
                    {detailKunjungan.korcab ? detailKunjungan.korcab.nama : "-"}
                  </span>
                </div>
              </div>

              <div className="profile-item mt-3 w-100">
                <span className="profile-label">
                  <i className="fas fa-comment-alt"></i> Keterangan
                </span>
                <span className="profile-value" style={{ whiteSpace: "pre-wrap", fontWeight: "400" }}>
                  {detailKunjungan.keterangan || "-"}
                </span>
              </div>
            </Col>

            {/* Kolom Kanan: Foto & GPS */}
            <Col xs={12} lg={6}>
              <div className="detail-section-title">
                <i className="fas fa-camera"></i> Foto Bukti Kunjungan
              </div>
              <div className="detail-image-wrapper">
                {buktiKunjungan ? (
                  loading ? (
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <ColorRing
                        visible={true}
                        height="60"
                        width="60"
                        colors={["#30B9FB", "#30B9FB", "#30B9FB", "#30B9FB", "#30B9FB"]}
                      />
                      <span className="text-muted mt-2 small">Memuat gambar...</span>
                    </div>
                  ) : (
                    <img
                      src={urlPreview}
                      alt="Bukti Kunjungan"
                      className="detail-image"
                    />
                  )
                ) : (
                  <div className="text-center p-4">
                    <div className="alert alert-warning border-0 text-warning font-weight-bold mb-3" style={{ background: "#fffbeb", borderRadius: "8px" }}>
                      Maaf, masih belum ada bukti Kunjungan untuk saat ini..
                    </div>
                    <img
                      src={require("assets/img/sorry.jpg")}
                      alt="Sorry"
                      style={{ maxWidth: "160px", borderRadius: "8px" }}
                    />
                  </div>
                )}
              </div>

              <div className="detail-section-title mt-4">
                <i className="fas fa-map-marked-alt"></i> Lokasi GPS
              </div>
              <div className="detail-map-wrapper">
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: "AIzaSyDEQbFkmNjBsVFEHW_pLszpxLNOXr5HLYk",
                  }}
                  center={{
                    lat: latitude || defaultProps.center.lat,
                    lng: longitude || defaultProps.center.lng,
                  }}
                  defaultZoom={defaultProps.zoom}
                >
                  {latitude !== null && longitude !== null && (
                    <AnyReactComponent
                      lat={latitude}
                      lng={longitude}
                    />
                  )}
                </GoogleMapReact>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Container fluid>
        <Button
          className="btn-back-custom"
          type="button"
          onClick={handleClick}
        >
          <i className="fas fa-arrow-left"></i>
        </Button>
        <Row>
          <Col md="12">
            <Card className="group-card">
              <Card.Header className="group-card-header">
                <Card.Title as="h3" className="group-title">
                  Kunjungan Per Group
                </Card.Title>
              </Card.Header>
              <Card.Body>
                {isLoading ? (
                  <div
                    className="loader-container"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "30vh",
                    }}
                  >
                    <Watch
                      visible={true}
                      height="80"
                      width="80"
                      radius="30"
                      color="#F75D59"
                      ariaLabel="watch-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                    <p className="text-muted mt-3">Memuat data kunjungan per group...</p>
                  </div>
                ) : (
                  <div>
                    {listKunjunganPerGroup.length > 0 ? (
                      <DataTable
                        columns={colGroupKunjungan}
                        data={listKunjunganPerGroup}
                        customStyles={customStyles}
                        paginationPerPage={totalPerHalaman}
                      />
                    ) : (
                      <div className="text-center py-5">
                        <div className="alert alert-warning border-0 text-warning font-weight-bold mb-4 d-inline-block px-4" style={{ background: "#fffbeb", borderRadius: "8px" }}>
                          Maaf, belum ada detail kunjungan nasabah saat ini.
                        </div>
                        <img
                          src={require("assets/img/sorry.jpg")}
                          alt="Sorry"
                          style={{
                            maxWidth: "200px",
                            borderRadius: "8px",
                            display: "block",
                            margin: "0 auto",
                          }}
                        />
                      </div>
                    )}

                    <div style={{ marginTop: 35 }}>
                      <Row className="align-items-center">
                        <Col xs={12} md={6} className="d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0">
                          <span style={{ fontWeight: "700", color: "#64748b", fontSize: "14px", marginRight: "12px" }}>
                            Baris per halaman:
                          </span>
                          <div style={{ width: "110px" }}>
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="Pilih Client"
                              value={options.find(
                                (option) => option.value === totalPerHalaman
                              )}
                              onChange={handlePageSizeChange}
                              options={options}
                              placeholder="Rows"
                              isSearchable={false}
                            />
                          </div>
                        </Col>

                        <Col xs={12} md={6} className="d-flex justify-content-center justify-content-md-end">
                          <ReactPaginate
                            forcePage={page}
                            containerClassName="paginations"
                            previousClassName="pages-itemss-containers"
                            previousLinkClassName="pages-links-labelss"
                            nextClassName="pages-itemss-containers"
                            nextLinkClassName="pages-links-labelss"
                            breakClassName="pages-itemss-containers"
                            pageCount={korcab.listDataKunjunganByGroup.totalPages || 1}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={1}
                            pageLinkClassName="pages-links-labelss"
                            pageClassName="pages-itemss-containers"
                            activeClassName="activees"
                            activeLinkClassName="aactivess"
                            nextLabel=" > "
                            previousLabel=" < "
                            initialPage={page}
                            disableInitialCallback={true}
                            onPageChange={(val) => {
                              setPage(val.selected);
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListKunjunganByGroup;
